export * from "./client";
export * from "./collect-stream-body";
export * from "./command";
export * from "./constants";
export * from "./create-aggregated-client";
export * from "./default-error-handler";
export * from "./defaults-mode";
export * from "./emitWarningIfUnsupportedVersion";
export * from "./exceptions";
export * from "./extended-encode-uri-component";
export * from "./extensions";
export * from "./get-array-if-single-item";
export * from "./get-value-from-text-node";
export * from "./is-serializable-header-value";
export * from "./NoOpLogger";
export * from "./object-mapping";
export * from "./resolve-path";
export * from "./ser-utils";
export * from "./serde-json";
export * from "@smithy/core/serde";
